import { defineStore, acceptHMRUpdate } from 'pinia'
import { tnApi } from '@/api'
import { useGlobalStore } from '@/pinia/GlobalStore'
import sortOn from 'sort-on'
import { useNotificationStore } from '@/pinia/NotificationStore'
import { v4 as uuidv4 } from 'uuid'

export const useEntityStore = defineStore('entities', {
  state: () => ({
    entities: [],
    meta: {},
    sites: {},
    contentParts: [],
    contentPartsUndo: [],
    entity: {},
    deletedLocations: [],
    contentSite: {},
    entityUndo: {},
    entitySettings: {},
    qualifiedSites: {},
    specialFeatures: [],
    entitySettingsUndo: {},
    user: {},
    media: null,
    sitesForType: [],
    sitesForRegion: [],
    sitesForActivity: [],
    marketingSites: [],
    holidayCategories: [],
    fullContentParts: [],
    aaul: false,
    settingsBackRoute: {},
    contentDictionary: {},
    isLoading: false,
    isLoadingQualifiedSites: false,
    isLoadingContent: false,
    isSavingContent: false,
    pois: [{
      id: 1,
      icon: 'plane',
      name: 'Flughafen'
    },
    {
      id: 2,
      icon: 'train',
      name: 'Bahnhof'
    },
    {
      id: 3,
      icon: 'ship',
      name: 'Fähre'
    },
    {
      id: 4,
      icon: 'beach',
      name: 'Strand'
    },
    {
      id: 5,
      icon: 'ripple',
      name: 'Wasser'
    },
    {
      id: 6,
      icon: 'basket',
      name: 'Einkaufen'
    },
    {
      id: 7,
      icon: 'tools-kitchen-2',
      name: 'Restaurant'
    },
    {
      id: 8,
      icon: 'aerial-lift',
      name: 'Skilift'
    },
    {
      id: 9,
      icon: 'stethoscope',
      name: 'Arzt'
    },
    {
      id: 10,
      icon: 'prescription',
      name: 'Apotheke'
    },
    {
      id: 11,
      icon: 'music',
      name: 'Nachtleben'
    },
    {
      id: 12,
      icon: 'target',
      name: 'Ortsmitte'
    },
    {
      id: 13,
      icon: 'bus-stop',
      name: 'Bus'
    },
    {
      id: 14,
      icon: 'road',
      name: 'Autobahn'
    }]
  }),
  getters: {
    changed: (state) => JSON.stringify(state.entity) !== JSON.stringify(state.entityUndo),
    globalTaxes: (state) => {
      const globalStore = useGlobalStore()
      return globalStore.params?.global_taxes?.filter(item => item.country_id === state.entity?.country_id) || []
    }
  },
  actions: {
    async loadParams (types) {
      const globalStore = useGlobalStore()
      await globalStore.loadParams(types)
    },
    async migrate (id, module = 'accommodations') {
      const {
        entitiesMigrate
      } = tnApi(true)
      await entitiesMigrate(id, module)
    },
    async migrateMedia (id, module = 'accommodations') {
      const {
        entitiesMigrateMedia
      } = tnApi(true)
      await entitiesMigrateMedia(id, module)
    },
    async save (id, module = 'accommodations') {
      const {
        entitiesSave
      } = tnApi(true)
      const { entity } = await entitiesSave(id, module, { entity: this.entity })
      // this.entity.is_obu_active = entity.is_obu_active
      // this.entityUndo = Object.assign({}, this.entity)
    },
    async savePayload (id, type = 'null', value = null, module = 'accommodations') {
      if (!id) return

      console.log(id, type, value)

      const payload = {}
      switch (type) {
        case 'matterport_id':
          payload.matterport_id = value
          this.entity.matterport_id = value
          break
        case 'holiday_categories':
          payload.holiday_categories = this.holidayCategories
          break
        case 'special_features':
          payload.special_features = this.specialFeatures
          break
        case 'contact':
          payload.contact = this.entity.contact
          break
        case 'pois':
          payload.pois = this.entity.pois
          break
        case 'near_places':
          payload.near_places = {
            items: this.entity.near_places,
            deletedIds: this.deletedLocations
          }
          break
        case 'near_destinations':
          payload.near_destinations = {
            items: this.entity.near_destinations,
            deletedIds: this.deletedLocations
          }
          break
        case 'gallery':
          payload.gallery = {
            part_id: value.part_id,
            ids: value.ids
          }
          break
        case 'primary_media':
          payload.primary_media = [
            {
              part_id: 16,
              ids: [value.preview]
            },
            {
              part_id: 17,
              ids: [value.summer]
            },
            {
              part_id: 18,
              ids: [value.winter]
            }
          ]
          break
      }
      const {
        entitiesSavePayload
      } = tnApi(true)
      const data = await entitiesSavePayload(id, module, payload)
      if (type === 'near_places') {
        const store = useEntityStore()
        store.$patch((state) => {
          state.entity.near_places = data.distances
        })
      }
      if (type === 'near_destinations') {
        const store = useEntityStore()
        store.$patch((state) => {
          state.entity.near_destinations = data.distances
        })
      }
    },
    async saveSettings (id, module = 'accommodations') {
      const {
        entitiesSaveSettings
      } = tnApi(true)
      const { settings } = await entitiesSaveSettings(id, module, { settings: this.entitySettings, entity: { is_obu_active: this.entity.is_obu_active } })
      this.entitySettings = settings
      this.entitySettingsUndo = Object.assign({}, settings)
    },
    async all (page = 1) {
      const globalStore = useGlobalStore()
      this.user = globalStore.user
      this.aaul = globalStore.aaul
      this.items = null
      this.isLoading = true
      const {
        entitiesAll
      } = tnApi(true)
      const data = await entitiesAll({ page })
      this.isLoading = false
      this.entities = data.entities.data
      this.meta = data.meta
    },
    unRemoveLocation (id) {
      if (!Number.isInteger(id)) {
        id = id.extraPayload.id
      }
      this.deletedLocations = this.deletedLocations.filter(item => item !== id)
    },
    removeLocation (location, item) {
      this.deletedLocations.push(location.id)
      const notificationStore = useNotificationStore()
      const text = `Du hast ${item} **${location.name}** aus der Umgebung gelöscht.`

      notificationStore.addUndoNotification(text, { id: location.id }, this.unRemoveLocation)
    },
    addLocation (type) {
      this.entity[type].push({
        id: uuidv4(),
        name: '',
        distance: 0,
        group_id: type === 'nearPlaces' ? 2 : 3
      })
    },
    changeGalleryItems (galleryId, ids) {
      const store = useEntityStore()

      const index = this.media.findIndex(item => item.part_id === galleryId)
      console.log(index)
      store.$patch((state) => {
        state.media[index].ids = ids
      })
    },
    async find (id) {
      if (id === undefined || !id) return
      this.isLoading = true
      const globalStore = useGlobalStore()
      this.user = globalStore.user
      this.aaul = globalStore.aaul
      this.entity = null
      const {
        entitiesFind
      } = tnApi(true)
      const data = await entitiesFind(id)
      this.entity = data.entity
      this.media = data.media
      this.sites = sortOn(data.sites, 'site.domain')
      this.holidayCategories = data.entity.holiday_categories.map(item => item.id)
      this.specialFeatures = data.entity.special_features.map(item => item.id)

      this.entity.catering = data.catering
      this.entity.contact.languages = data.entity.contact.languages.map(item => item.id)

      if (data.entity.pois.length) {
        const pois = {}
        for (const poi of data.entity.pois) {
          pois[poi.poi_id] = poi.distance
        }
        data.entity.pois = pois
      }

      this.entitySettings = data.entity.settings !== null
        ? data.entity.settings
        : {
            interval: 1
          }
      this.entitySettingsUndo = Object.assign({}, this.entitySettings)
      this.entityUndo = Object.assign({}, this.entity)
      this.isLoading = false
    },
    async getQualifiedSites (id, module = 'accommodations') {
      this.isLoadingQualifiedSites = true
      const {
        entitiesGetQualifiedSites
      } = tnApi(true)
      const data = await entitiesGetQualifiedSites(id, module)
      this.sitesForRegion = data.sitesForRegion
      this.sitesForType = data.sitesForType
      this.sitesForActivity = data.sitesForActivity
      this.marketingSites = data.marketingSites
      this.isLoadingQualifiedSites = false
    },
    async removeSite (id, siteId, module = 'accommodations') {
      const {
        entitiesRemoveSite
      } = tnApi(true)
      const data = await entitiesRemoveSite(id, siteId, module)
      const store = useEntityStore()
      store.$patch((state) => {
        state.sites = sortOn(data.sites, 'site.domain')
        state.contentParts = null
        state.contentSite = null
        state.contentPartsUndo = null
      })
    },
    async addSites (id, sites, module = 'accommodations') {
      const {
        entitiesAddSites
      } = tnApi(true)
      const data = await entitiesAddSites(id, module, { sites })
      const store = useEntityStore()
      store.$patch((state) => {
        state.sites = sortOn(data.sites, 'site.domain')
      })
    },
    async getSiteContent (id, siteId, lang = 'de', module = 'accommodations') {
      if (id === undefined) return
      console.log(siteId)
      this.isLoadingContent = true
      const {
        entitiesGetSiteContent
      } = tnApi(true)
      const data = await entitiesGetSiteContent(id, module, siteId, lang)
      this.isLoadingContent = false
      this.fullContentParts = data.fullContentParts
      this.contentSite = data.contentSite
      console.log(data)
      this.contentPartsUndo = Object.assign({}, this.fullContentParts)
    },
    async saveSiteContent (id, siteId, lang = 'de', module = 'accommodations') {
      if (id === undefined) return
      this.isSavingContent = true

      const {
        entitiesSaveSiteContent
      } = tnApi(true)
      const data = await entitiesSaveSiteContent(id, module, siteId, lang, { contentParts: this.fullContentParts })
      const store = useEntityStore()
      store.$patch((state) => {
        state.fullContentParts = data.fullContentParts
      })
      this.isSavingContent = false
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEntityStore, import.meta.hot))
}
